import { App } from 'vue'
import Spinner from './LpSpinner.vue'

Spinner.install = (Vue: App) => {
  Vue.component(Spinner.name, Spinner)
}

export default Spinner
